import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import escape from '../utils/escape';

import ListItem from './ListItem';

require.ensure([], () => {
    require('./AutoTaskInput.less');
});

class AutoAttributeInput extends React.Component {

    constructor(props, context) {
        super(props, context);

        let codeValues = this.props.codeValues;
        codeValues.sort((a, b) => a.value.localeCompare(b.value));

        this.state = {
            text: this.props.defaultText,
            selectedID: null,
            selectedName: null,
            selectedIndex: 0,
            scrollTop: 0,
            filteredCodeValues: codeValues,
            codeValues: codeValues,
            focused: false,
            blurTimeout: null
        };

    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        this.setState({
            popupWidth: ReactDOM.findDOMNode(this.refs.attributeField).offsetWidth,
            popupLeft: ReactDOM.findDOMNode(this.refs.attributeField).offsetLeft,
            popupTop: ReactDOM.findDOMNode(this.refs.attributeField).offsetHeight + ReactDOM.findDOMNode(this.refs.attributeField).offsetTop - 1
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            text: nextProps.defaultText
        });
    }

    componentWillUnmount = () => {
        clearTimeout(this.state.blurTimeout);
    }

    // EVENT HANDLERS

    handleBlur = (focusEvent) => {
        this.setState({
            blurTimeout: setTimeout(() => {
                this.setState({
                    focused: false,
                    selectedIndex: 0,
                    forcePopup: false
                });
            }, 200)
        });
    }

    handleChange = (changeEvent) => {
        let text = changeEvent.target.value;

        this.setState({
            text: text,
            selectedID: null,
            selectedValue: null,
            selectedIndex: 0,
            scrollTop: 0,
            focused: true
        });

        this.filterCodeValues(text);
    }

    handleFocus =  (focusEvent) => {
        this.setState({
            focused: true,
            selectedIndex: 0
        });

        this.filterCodeValues(this.state.text);
    }

    handleKeyDown = (keyEvent) => {
        let newScrollTop = this.state.scrollTop;

        if (keyEvent.key === "Tab") {
            keyEvent.key = "Enter";
            this.handleKeyPress(keyEvent);
        } else if (keyEvent.key === "ArrowUp" && this.state.selectedIndex - 1 >= 0) {
            // calculate the new position by subtracing height of one item and then set it
            if (this.refs.popup) {
                ReactDOM.findDOMNode(newScrollTop = this.state.scrollTop - this.refs["item" + (this.state.selectedIndex - 1)]).scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            this.setState({
                selectedIndex: this.state.selectedIndex - 1,
                focused: true,
                scrollTop: newScrollTop
            });
        } else if (keyEvent.key === "ArrowDown" && this.state.selectedIndex + 1 < this.state.filteredCodeValues.length) {
            // calculate the new position by adding height of one item but watching that it doesn't go over max height
            if (this.refs.popup) {
                ReactDOM.findDOMNode(newScrollTop = this.state.scrollTop + this.refs["item" + (this.state.selectedIndex + 1)]).scrollHeight;
                let popupDOMNode = ReactDOM.findDOMNode(this.refs.popup);
                if (newScrollTop > popupDOMNode.scrollHeight) newScrollTop = popupDOMNode.scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            // filter since we are gonna show the popup list
            let filter = new RegExp(escape.escapeInput(this.state.text), 'i');

            this.setState({
                selectedIndex: this.state.selectedIndex + 1,
                focused: true,
                scrollTop: newScrollTop,
                filteredCodeValues: this.state.codeValues.filter(codeValue => filter.test(codeValue.value))
            });
        } else if (keyEvent.key === "Escape" && this.state.focused) {
            // don't close the create pill outside
            keyEvent.stopPropagation();

            this.setState({
                focused: false
            });
        }
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            // filter once again but this time trimmed
            this.filterCodeValues(this.state.text.trim());

            if (this.state.filteredCodeValues.length === 1) {
                // only one matches, set the state to that task and clear focus so the popup isn't annoying
                this.setState({
                    text: this.state.filteredCodeValues[0].value,
                    selectedID: this.state.filteredCodeValues[0].code,
                    selectedValue: this.state.filteredCodeValues[0].value,
                    selectedIndex: 0,
                    scrollTop: 0,
                    focused: false
                },
                this.handleMouseDown(0));
            } else if (this.state.filteredCodeValues.length > 1) {
                this.setState({
                    text: this.state.filteredCodeValues[0].value,
                    selectedID: this.state.filteredCodeValues[0].code,
                    selectedValue: this.state.filteredCodeValues[0].value,
                    selectedIndex: this.state.selectedIndex,
                    scrollTop: 0,
                    focused: false
                },
                this.handleMouseDown(this.state.selectedIndex));
            }

            keyEvent.stopPropagation();
        }
    }

    handleMouseDown = (selectedIndex) => {
        // called on left click
        let codeValue = {
            value: this.state.filteredCodeValues[selectedIndex].value,
            code: this.state.filteredCodeValues[selectedIndex].code,
            id: this.state.filteredCodeValues[selectedIndex].code
        };

        this.props.handleFunction(this.props.attributeID, codeValue);

        if (this.props.keepAfterClick) {
            let text = codeValue.value;
            this.setState({
                text: text
            });
        }
        else {
                this.setState({
                text: '',
                selectedID: null,
                selectedValue: null,
                selectedIndex: 0,
                scrollTop: 0,
                focused: false
            });
        }
    }

    handleMouseOver = (selectedIndex) => {
        this.setState({
            selectedIndex: selectedIndex,
        });
    }

    handleScroll = () => {
        if (this.state.blurTimeout) {
            clearTimeout(this.state.blurTimeout);
            this.setState({
                blurTimeout: null
            });
            ReactDOM.findDOMNode(this.refs.attributeField).focus();
        }
    }

    // OTHER METHODS

    clear = () => {
        this.setState({
            text: "",
            selectedID: null,
            selectedValue: null,
            selectedIndex: 0,
            scrollTop: 0,
            filteredCodeValues: this.state.codeValues,
            focused: false,
        }, () => {
            let codeValue = {
                value: null,
                code: null,
                id: null
            };

            this.props.handleFunction(this.props.attributeID, codeValue);
        });
    }

    filterCodeValues =  (userInput) => {
        if (userInput === '') {
            this.setState({
                filteredCodeValues: this.state.codeValues
            });

            return;
        }

        let filter = new RegExp(escape.escapeInput(userInput), 'i');

        // delay set so it's not annoyingly fast and changing instantly at every character
        setTimeout(() => {
            this.setState({
                filteredCodeValues: this.state.codeValues.filter(codeValue => filter.test(codeValue.value))
            });
        }, 300);
    }

    getSelectedValue = () => {
        return this.state.selectedValue;
    }

    getSelectedId = () => {
        return this.state.selectedID;
    }

    // RENDER METHOD

    render = () => {
        return (
            <span>
                <label>
                    {this.props.label}
                </label>
                <input
                    style={{display: "inline"}}
                    type="input"
                    ref="attributeField"
                    className="form-control"
                    value={this.state.text}
                    placeholder={this.props.placeholder}
                    onKeyDown={this.handleKeyDown}
                    onKeyPress={this.handleKeyPress}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    readOnly={this.props.readOnly ? "readonly" : ""}
                    />
                   {
                        this.props.enableClear && this.state.text ?
                        <a style={{"cursor" : "pointer", "paddingRight" : "20px", "marginTop" : "5px"}} onClick={this.clear} className="filter-clear"><span><span className="md-clear"></span></span></a>
                        : null
                    }
                {
                    this.state.focused && this.state.filteredCodeValues.length > 0 && !this.props.readOnly
                    ?
                        (
                            <ul className="popup" onScroll={this.handleScroll} style={{ "width": this.state.popupWidth + "px", "top": this.state.popupTop + "px", "left": this.state.popupLeft + "px" }} ref="popup" onClick={this.handleClick}>
                                {
                                    this.state.filteredCodeValues.map((codeValue, i) => {
                                        let classNames = classnames({
                                            'popup-text': i != this.state.selectedIndex,
                                            'popup-text-selected': i === this.state.selectedIndex
                                        });

                                        return (
                                            <ListItem
                                                ref={"item" + i}
                                                classNames={classNames}
                                                key={i}
                                                id={i}
                                                index={i}
                                                mouseDown={this.handleMouseDown}
                                                mouseOver={this.handleMouseOver}
                                                name={codeValue.value}
                                                />
                                        );
                                    })
                                }
                            </ul>
                        )
                    : null
                }
            </span>
        );
    }
}

AutoAttributeInput.propTypes = {
    codeValues: PropTypes.array,
    handleFunction: PropTypes.func,
    attributeID: PropTypes.number,
    keepAfterClick: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    defaultText: PropTypes.string,
    enableClear: PropTypes.bool,
    readOnly: PropTypes.bool
};

AutoAttributeInput.defaultProps = {
    defaultText: ""
};

export default connect()(AutoAttributeInput);



/** WEBPACK FOOTER **
 ** ./src/app/components/AutoAttributeInput.js
 **/